import React from 'react'
import styled from 'styled-components'

type FlagProps = {
    lang: string
}

const Flag: React.FunctionComponent<FlagProps> = ({ lang }) => (
    <Container href={`/${lang}`}>
        <Image src={require(`./images/${lang}.png`)} />
    </Container>
)

const Container = styled.a`
    width: 20px;

    &, &:visited, &:active, &:hover {
        text-decoration: none;
        outline: none;
    }
`

const Image = styled.img`
    width: 100%;
`

export default Flag